import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormHelperText,
} from "@mui/material";

const AddReportDialog = ({ open, onClose, onAdd, report }) => {
  const [msrsReport, setMsrsReport] = useState("");
  const [description, setDescription] = useState("");
  const [individualOrder, setIndividualOrder] = useState(false);
  const [parameterPrompts, setParameterPrompts] = useState(false);
  const [reportType, setReportType] = useState("");
  const [updateorderstatus, setUpdateorderstatus] = useState(false);
  const [labelreport, setLabelreport] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (report) {
      setMsrsReport(report.msrsReport || "");
      setDescription(report.description || "");
      setIndividualOrder(report.individualOrder || false);
      setParameterPrompts(report.parameterPrompts || false);
      setReportType(report.reportType || "");
      setUpdateorderstatus(report.updateorderstatus || false);
      setLabelreport(report.labelreport || false);
    }
  }, [report]);

  const handleAddClick = () => {
    if (validateForm()) {
      onAdd({
        msrsReport,
        description,
        individualOrder,
        parameterPrompts,
        reportType,
        recordid: report?.recordid || 0,
        updateorderstatus,
        labelreport,
      });
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!msrsReport.trim()) {
      errors.msrsReport = "Report Name is required";
    }
    if (!description.trim()) {
      errors.description = "Description is required";
    }
    if (!reportType.trim()) {
      errors.reportType = "Report Type is required";
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleClose = () => {
    setMsrsReport("");
    setDescription("");
    setIndividualOrder(false);
    setParameterPrompts(false);
    setReportType("");
    setUpdateorderstatus(false);
    setLabelreport(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{report ? "Edit Report" : "Add New Report"}</DialogTitle>
      <DialogContent>
        <form>
          <FormControl fullWidth margin="normal" error={!!errors.msrsReport}>
            <TextField
              label="Report file name"
              value={msrsReport}
              onChange={(e) => setMsrsReport(e.target.value)}
              fullWidth
              margin="normal"
            />
            {errors.msrsReport && (
              <FormHelperText>{errors.msrsReport}</FormHelperText>
            )}
          </FormControl>

          <FormControl fullWidth margin="normal" error={!!errors.description}>
            <TextField
              label="Description/Title"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              fullWidth
              margin="normal"
            />
            {errors.description && (
              <FormHelperText>{errors.description}</FormHelperText>
            )}
          </FormControl>

          <FormControlLabel
            control={
              <Checkbox
                checked={individualOrder}
                onChange={(e) => setIndividualOrder(e.target.checked)}
              />
            }
            label="Individual Order"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={parameterPrompts}
                onChange={(e) => setParameterPrompts(e.target.checked)}
              />
            }
            label="Parameter Prompts"
          />

          <FormControl
            variant="outlined"
            fullWidth
            margin="normal"
            error={!!errors.reportType}
          >
            <InputLabel>Report Type</InputLabel>
            <Select
              value={reportType}
              onChange={(e) => setReportType(e.target.value)}
              label="Report Type"
            >
              <MenuItem value="LAB">Lab</MenuItem>
              <MenuItem value="QAQC">QAQC</MenuItem>
              <MenuItem value="ADMIN">Admin</MenuItem>
              <MenuItem value="INVOICE">Invoice</MenuItem>
              <MenuItem value="QUOTE">Quote</MenuItem>
              <MenuItem value="OTHER">Other</MenuItem>
            </Select>
            {errors.reportType && (
              <FormHelperText>{errors.reportType}</FormHelperText>
            )}
          </FormControl>

          <FormControlLabel
            control={
              <Checkbox
                checked={updateorderstatus}
                onChange={(e) => setUpdateorderstatus(e.target.checked)}
              />
            }
            label="Update Order Status"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={labelreport}
                onChange={(e) => setLabelreport(e.target.checked)}
              />
            }
            label="Label Report"
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleAddClick} variant="contained" color="primary">
          {report ? "Save" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddReportDialog;
